import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {

  return (
    <section id="hero-section" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover z-0"
        autoPlay
        muted
        playsInline
        preload="auto"
        style={{ 
          filter: 'brightness(1.1) contrast(0.9)',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden'
        }}
        ref={(video) => {
          if (video) {
            try {
              video.addEventListener('loadeddata', () => {
                video.playbackRate = 1; // Start at normal speed
              });

              // Two-stage slowdown as video approaches the end
              video.addEventListener('timeupdate', () => {
                if (video.duration) {
                  const progress = video.currentTime / video.duration;
                  
                  if (progress >= 0.75) { // Last 25% of video
                    video.playbackRate = 0.75; // Slow stage
                  } else {
                    video.playbackRate = 1; // Normal speed
                  }
                }
              });
              
              // Ensure video stops on the last frame
              video.addEventListener('ended', () => {
                video.currentTime = video.duration; // Stay on last frame
              });
              
              // Additional smoothness optimizations
              video.style.willChange = 'transform';
            } catch (error) {
              console.log('Video setup failed:', error);
            }
          }
        }}
      >
        <source src="/Desert_Landscape.mp4" type="video/mp4" />
      </video>

      {/* Lighter Video Overlay */}
      <div className="absolute inset-0 bg-white/20 z-5"></div>



      <div className="container-max section-padding relative z-10">
        <div className="relative min-h-[80vh] flex flex-col justify-center py-8">
          {/* Top Section - Large Name */}
          <div className="mb-12 pt-12">
            {/* Large Name */}
            <motion.h1
              className="text-6xl md:text-7xl lg:text-8xl xl:text-[10rem] font-bold text-text-main leading-[0.85] tracking-tight text-center"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              ROBISON<br />
              ROGERS
            </motion.h1>
          </div>

          {/* Centered Content Section with increased spacing */}
          <div className="flex flex-col justify-center items-center flex-grow text-center px-8 -mt-6">
            <motion.div
              className="max-w-4xl space-y-8"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold leading-tight tracking-tight whitespace-nowrap" style={{ color: '#F3E9DD' }}>
                Impact-Driven Product Leader
              </h2>
              
              <p className="text-xl md:text-2xl lg:text-3xl leading-relaxed max-w-3xl mx-auto mt-8" style={{ color: '#F8F7F4' }}>
                Turning deep user insights into category-defining products that drive growth.
              </p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator with increased bottom spacing */}
      <motion.div
        className="absolute bottom-6 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 border-2 rounded-full flex justify-center" style={{ borderColor: '#F8F7F4' }}>
          <div className="w-1 h-3 rounded-full mt-2" style={{ backgroundColor: '#F8F7F4' }}></div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero; 